import { Button, Switch } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Vocabulary } from "../../Utils/Vocabulary";
import { VisuallyHiddenInput } from "./VisuallyHiddenInput";

interface CreateVehicleMainInfoColumnsOptions {
  onUploadLocationLogo: (file: File, locationData: any) => void;
  onUploadBrandLogo: (file: File, brandData: any) => void;
  genericAutocompleteModelData: any[];
}

export function createVehicleMainInfoColumns({
  onUploadLocationLogo,
  onUploadBrandLogo,
  genericAutocompleteModelData,
}: CreateVehicleMainInfoColumnsOptions) {
  const columnsLocatieAdministrativa = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "nume",
      label: "Oras",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "judet",
      label: "Judet",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "adresa",
      label: "Adresa",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "telefon",
      label: "Telefon",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "active",
      label: Vocabulary.active,
      options: {
        filter: true,
        sort: false,
        type: "boolean",
        customBodyRender: (value: any) => {
          return <Switch checked={Boolean(value)} disabled />;
        },
      },
    },
    {
      name: "logo",
      label: "Logo",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                color="primary"
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
              >
                {Vocabulary.upload}
                <VisuallyHiddenInput
                  type="file"
                  onChange={(event) =>
                    onUploadLocationLogo(
                      event.target.files![0],
                      genericAutocompleteModelData[tableMeta.rowIndex],
                    )
                  }
                  accept="image/png, image/jpg, image/jpeg"
                />
              </Button>

              {value ? (
                <img
                  style={{
                    padding: "4px",
                  }}
                  src={`/api/${value}`}
                  width={100}
                  alt="Location logo"
                />
              ) : null}
            </div>
          );
        },
      },
    },
  ];

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "nume",
      label: "Nume",
      options: {
        filter: true,
        sort: false,
      },
    },
  ];

  const columnsFirmaAchizitie = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "nume_firma",
      label: "Nume",
      options: {
        filter: true,
        sort: false,
      },
    },
  ];

  const columnsTipTVA = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "nume",
      label: "Nume",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "valoare",
      label: "Valoare",
      options: {
        filter: true,
        sort: false,
      },
    },
  ];

  const columnsBrand = [
    ...columns,
    {
      name: "logo",
      label: "Logo",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                color="primary"
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
              >
                {Vocabulary.upload}
                <VisuallyHiddenInput
                  type="file"
                  onChange={(event) =>
                    onUploadBrandLogo(
                      event.target.files![0],
                      genericAutocompleteModelData[tableMeta.rowIndex],
                    )
                  }
                  accept="image/png, image/jpg, image/jpeg"
                />
              </Button>

              {value ? <img src={`/api/${value}`} width={100} /> : null}
            </div>
          );
        },
      },
    },
  ];

  const purchaseTypeColumns = [
    { name: "id", label: "ID", options: { filter: true, sort: false, display: false } },
    { name: "nume", label: "Nume", options: { filter: true, sort: false } },
    {
      name: "applies_interest",
      label: Vocabulary.appliesInterest,
      options: {
        filter: true,
        sort: false,
        type: "boolean",
        customBodyRender: (value: any) => (value ? Vocabulary.yes : Vocabulary.no),
      },
    },
  ];

  return {
    columnsLocatieAdministrativa,
    columns,
    columnsFirmaAchizitie,
    columnsTipTVA,
    columnsBrand,
    purchaseTypeColumns,
  };
}

export default createVehicleMainInfoColumns;
